
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOurCompaniesDetailsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"company_nickname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"company_is_active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"company_nickname"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"company_nickname"}}}]}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_nickname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_reference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_address_line_1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_address_line_2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_post_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_country"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_org_num"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_tel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_bank_giro"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bic_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iban_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_image_link"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_order_tel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_customer_service_tel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_finans_tel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_order_email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_customer_service_email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_finans_email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_logo_64base"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_watermark_64base"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"about_us_64base"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":698}};
    doc.loc.source = {"body":"# @format\n\nquery GetOurCompaniesDetailsQuery($company_nickname: String!) {\n\tcompanies(\n\t\twhere: {\n\t\t\tcompany_is_active: { _eq: true }\n\t\t\tcompany_nickname: { _eq: $company_nickname }\n\t\t}\n\t) {\n\t\tcompany_nickname\n\t\tcompany_name\n\t\tcompany_reference\n\t\tcompany_address_line_1\n\t\tcompany_address_line_2\n\t\tcompany_city\n\t\tcompany_post_code\n\t\tcompany_state\n\t\tcompany_country\n\t\tcompany_org_num\n\t\tcompany_tel\n\t\tcompany_email\n\t\tcompany_bank_giro\n\t\tbic_code\n\t\tiban_code\n\t\tcompany_image_link\n\t\tcompany_order_tel\n\t\tcompany_customer_service_tel\n\t\tcompany_finans_tel\n\t\tcompany_order_email\n\t\tcompany_customer_service_email\n\t\tcompany_finans_email\n\t\tcompany_logo_64base\n\t\tcompany_watermark_64base\n\t\tabout_us_64base\n\t}\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["GetOurCompaniesDetailsQuery"] = oneQuery(doc, "GetOurCompaniesDetailsQuery");
        
